module.exports = __webpack_public_path__ + "static/header_qliksense-ff2213ef874e2442aa4bdffc60a84541.webp";